import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DacDetails, PaaTaskDetails, PpmDetails, Tasks } from '@/types';

@Injectable({
  providedIn: 'root',
})
export class CurrentTasksService {
  AGPMBASEURL = `${environment.api.agpmUrl}/agpms/flowable/tasks`;
  PAABASEURL = `${environment.api.paaUrl}/paas`;
  PPMBASEURL = `${environment.api.ppmUrl}/ppms`;
  DACBASEURL = `${environment.api.dacUrl}`;
  REPORT_REQUEST_BASEURL = `${environment.api.reportUrl}/flowable`;
  ECLAIRCISSEMENT_BASEURL = `${environment.api.eclaircissementUrl}/flowable`;

  httpClient = inject(HttpClient);

  // agpm
  getAllAgpmsTasks(): Observable<any> {
    return this.httpClient.get<any>(`${this.AGPMBASEURL}`);
  }

  getUserAgpmTasks(): Observable<Tasks> {
    return this.httpClient.get<Tasks>(`${this.AGPMBASEURL}/user`);
  }

  getTaskDetailsAgpm(taskId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.AGPMBASEURL}/${taskId}`);
  }

  validateAgpm(taskId: number, agpmFormData: FormData): Observable<any> {
    return this.httpClient.post<any>(`${this.AGPMBASEURL}/${taskId}/validate`, agpmFormData);
  }

  //paa
  getAllPaasTasks(): Observable<any> {
    return this.httpClient.get<any>(`${this.PAABASEURL}/flowable/tasks`);
  }

  getUserPaaTasks(): Observable<Tasks> {
    return this.httpClient.get<Tasks>(`${this.PAABASEURL}/flowable/tasks/user`);
  }

  getTaskDetailsPaa(taskId: string): Observable<PaaTaskDetails> {
    return this.httpClient.get<any>(`${this.PAABASEURL}/flowable/tasks/${taskId}`);
  }

  validatePaa(taskId: number, paaFormData: FormData): Observable<any> {
    return this.httpClient.post<any>(`${this.PAABASEURL}/flowable/tasks/${taskId}/validate`, paaFormData);
  }

  //ppm
  getAllPpmsTasks(): Observable<any> {
    return this.httpClient.get<any>(`${this.PPMBASEURL}/flowable/tasks`);
  }

  getUserPpmTasks(): Observable<Tasks> {
    return this.httpClient.get<Tasks>(`${this.PPMBASEURL}/flowable/tasks/user`);
  }

  getTaskDetailsPpm(taskId: string): Observable<PpmDetails> {
    return this.httpClient.get<PpmDetails>(`${this.PPMBASEURL}/flowable/tasks/${taskId}`);
  }

  validatePpm(taskId: number, ppmFormData: FormData): Observable<any> {
    return this.httpClient.post<any>(`${this.PPMBASEURL}/flowable/tasks/${taskId}/validate`, ppmFormData);
  }

  //dac
  getTaskDetailsDac(taskId: string): Observable<DacDetails> {
    return this.httpClient.get<DacDetails>(`${this.DACBASEURL}/flowable/tasks/${taskId}`);
  }

  validateDac(taskId: number, dacFormData: FormData): Observable<any> {
    return this.httpClient.post<any>(`${this.DACBASEURL}/flowable/tasks/${taskId}/validate`, dacFormData);
  }

  getUserDacTasks(): Observable<Tasks> {
    return this.httpClient.get<Tasks>(`${this.DACBASEURL}/flowable/tasks/user`);
  }

  //report
  getUserReportRequestTasks(): Observable<Tasks> {
    return this.httpClient.get<Tasks>(`${this.REPORT_REQUEST_BASEURL}/report/tasks/user`);
  }

  //eclaircissement
  getUserEclaircissementTasks(): Observable<Tasks> {
    return this.httpClient.get<Tasks>(`${this.ECLAIRCISSEMENT_BASEURL}/tasks/user`);
  }
}
